import React, {Fragment} from "react";
import HierarchicalCodelistsList from "./List";
import HierarchicalCodelistDetail from "./Detail";
import {translate} from 'react-i18next';
import {
  changeHierarchicalCodelistsHierarchicalCodelistClone,
  changeHierarchicalCodelistsHierarchicalCodelistDownload,
  changeHierarchicalCodelistsHierarchicalCodelistExport,
  downloadHierarchicalCodelistsHierarchicalCodelist,
  hideHierarchicalCodelistsHierarchicalCodelistClone,
  hideHierarchicalCodelistsHierarchicalCodelistDownload,
  hideHierarchicalCodelistsHierarchicalCodelistExport,
  hideHierarchicalCodelistsHierarchicalCodelistExportReport,
  submitHierarchicalCodelistsHierarchicalCodelistClone,
  submitHierarchicalCodelistsHierarchicalCodelistExport
} from "./actions";
import {compose} from "redux";
import {connect} from "react-redux";
import EnhancedModal from "../../../components/enhanced-modal";
import {MODAL_WIDTH_MD, MODAL_WIDTH_SM} from "../../../styles/constants";
import {Button, Modal} from "antd";
import {isCloneDestTripletValid, isExportDestinationValid} from "../../../utils/artefactValidators";
import ArtefactCloneForm from "../../../components/artefact-clone-form";
import ArtefactExportForm from "../../../components/artefact-export-form";
import ArtefactExportReport from "../../../components/artefact-export-report";
import {
  ARTEFACT_TYPE_HIERARCHICAL_CODELIST,
  ARTEFACT_TYPE_MULTIPLE,
  DOWNLOAD_FORMAT_TYPE_CSV,
  getArtefactDownloadOptions
} from "../../../constants/download";
import ArtefactDownloadForm from "../../../components/artefact-download-form";
import {getStringFromArtefactTriplet} from "../../../utils/sdmxJson";

const mapStateToProps = state => ({
  endpoints: state.config.nodes,
  endpointId: state.app.endpointId,
  hierarchicalCodelist: state.scenes.metaManager.hierarchicalCodelists.hierarchicalCodelist,
  allAgencies: state.scenes.metaManager.hierarchicalCodelists.allAgencies,
  downloadHierarchicalCodelistTriplets: state.scenes.metaManager.hierarchicalCodelists.downloadHierarchicalCodelistTriplets,
  downloadHierarchicalCodelistLang: state.scenes.metaManager.hierarchicalCodelists.downloadHierarchicalCodelistLang,
  downloadHierarchicalCodelistParams: state.scenes.metaManager.hierarchicalCodelists.downloadHierarchicalCodelistParams,
  cloneDestTriplet: state.scenes.metaManager.hierarchicalCodelists.cloneDestTriplet,
  hierarchicalCodelistExportSourceTriplet: state.scenes.metaManager.hierarchicalCodelists.hierarchicalCodelistExportSourceTriplet,
  hierarchicalCodelistExportDestination: state.scenes.metaManager.hierarchicalCodelists.hierarchicalCodelistExportDestination,
  hierarchicalCodelistExportReport: state.scenes.metaManager.hierarchicalCodelists.hierarchicalCodelistExportReport,
  user: state.app.user
});

const mapDispatchToProps = dispatch => ({
  onCloneHide: () => dispatch(hideHierarchicalCodelistsHierarchicalCodelistClone()),
  onCloneChange: fields => dispatch(changeHierarchicalCodelistsHierarchicalCodelistClone(fields)),
  onCloneSubmit: (cloneDestTriplet, srcHierarchicalCodelist, annotationsConfig) =>
    dispatch(submitHierarchicalCodelistsHierarchicalCodelistClone(cloneDestTriplet, srcHierarchicalCodelist, annotationsConfig)),
  onExportHide: () => dispatch(hideHierarchicalCodelistsHierarchicalCodelistExport()),
  onExportChange: fields => dispatch(changeHierarchicalCodelistsHierarchicalCodelistExport(fields)),
  onExportSubmit: (sourceTriplet, destination) => dispatch(submitHierarchicalCodelistsHierarchicalCodelistExport(sourceTriplet, destination)),
  onExportReportHide: () => dispatch(hideHierarchicalCodelistsHierarchicalCodelistExportReport()),
  onDownloadHide: () => dispatch(hideHierarchicalCodelistsHierarchicalCodelistDownload()),
  onDownloadChange: fields => dispatch(changeHierarchicalCodelistsHierarchicalCodelistDownload(fields)),
  onDownload: (hierarchicalCodelistTriplets, downloadHierarchicalCodelistParams, lang) =>
    dispatch(downloadHierarchicalCodelistsHierarchicalCodelist(hierarchicalCodelistTriplets, downloadHierarchicalCodelistParams, lang)),
});

const HierarchicalCodelists = ({
                                 t,
                                 endpoints,
                                 cloneDestTriplet,
                                 hierarchicalCodelist,
                                 endpointId,
                                 allAgencies,
                                 onCloneHide,
                                 onCloneChange,
                                 onCloneSubmit,
                                 hierarchicalCodelistExportSourceTriplet,
                                 hierarchicalCodelistExportDestination,
                                 hierarchicalCodelistExportReport,
                                 user,
                                 onExportHide,
                                 onExportChange,
                                 onExportSubmit,
                                 onExportReportHide,
                                 onDownloadHide,
                                 onDownloadChange,
                                 onDownload,
                                 downloadHierarchicalCodelistParams,
                                 downloadHierarchicalCodelistTriplets,
                                 downloadHierarchicalCodelistLang
                               }) =>
  <Fragment>
    <HierarchicalCodelistsList/>
    <HierarchicalCodelistDetail/>
    <EnhancedModal
      visible={cloneDestTriplet !== null}
      width={MODAL_WIDTH_MD}
      title={t('commons.artefact.modals.clone.title')}
      onCancel={onCloneHide}
      footer={
        <div>
          <Button onClick={onCloneHide}>
            {t('commons.buttons.close.title')}
          </Button>
          <Button
            onClick={() => {
              if (!isCloneDestTripletValid(cloneDestTriplet)) {
                Modal.warning({
                  title: t('commons.alerts.invalidForm.title'),
                  content: t('commons.alerts.invalidForm.content')
                });
              } else {
                onCloneSubmit(cloneDestTriplet, hierarchicalCodelist,
                  endpoints.find(endpoint => endpoint.general.id === endpointId).annotations
                );
              }
            }}
            type="primary"
          >
            {t('commons.artefact.modals.clone.buttons.submit.title')}
          </Button>
        </div>
      }
    >
      <ArtefactCloneForm
        agencies={allAgencies}
        srcArtefact={hierarchicalCodelist}
        destTriplet={cloneDestTriplet}
        onChange={onCloneChange}
      />
    </EnhancedModal>
    <EnhancedModal
      visible={hierarchicalCodelistExportSourceTriplet !== null}
      title={t('commons.artefact.modals.export.title')}
      width={MODAL_WIDTH_MD}
      onCancel={onExportHide}
      footer={
        <div>
          <Button onClick={onExportHide}>{t('commons.buttons.close.title')}</Button>
          <Button
            type="primary"
            onClick={() => {
              if (isExportDestinationValid(hierarchicalCodelistExportDestination, (user && user.providerId) !== null)) {
                onExportSubmit(hierarchicalCodelistExportSourceTriplet, hierarchicalCodelistExportDestination)
              } else {
                Modal.warning({
                  title: t('commons.alerts.invalidForm.title'),
                  content: t('commons.alerts.invalidForm.content')
                });
              }
            }}
          >
            {t('commons.artefact.modals.export.buttons.submit.title')}
          </Button>
        </div>
      }
    >
      <ArtefactExportForm
        type='hierarchicalcodelist'
        agencies={allAgencies}
        sourceTriplet={hierarchicalCodelistExportSourceTriplet}
        destination={hierarchicalCodelistExportDestination}
        onChange={onExportChange}
      />
    </EnhancedModal>
    <EnhancedModal
      visible={hierarchicalCodelistExportReport !== null}
      title={t('commons.artefact.modals.exportReport.title')}
      width={MODAL_WIDTH_MD}
      onCancel={onExportReportHide}
      footer={<Button onClick={onExportReportHide}>{t('commons.buttons.close.title')}</Button>}
    >
      <ArtefactExportReport
        report={hierarchicalCodelistExportReport}
      />
    </EnhancedModal>
    <EnhancedModal
      visible={downloadHierarchicalCodelistTriplets !== null && downloadHierarchicalCodelistTriplets !== undefined}
      onCancel={onDownloadHide}
      footer={
        <div>
          <Button onClick={onDownloadHide}>
            {t('commons.buttons.close.title')}
          </Button>
          <Button
            onClick={
              () => onDownload(downloadHierarchicalCodelistTriplets, downloadHierarchicalCodelistParams, downloadHierarchicalCodelistLang)
            }
            type="primary"
            disabled={
              (downloadHierarchicalCodelistParams && downloadHierarchicalCodelistParams.format === null) ||
              (downloadHierarchicalCodelistParams && downloadHierarchicalCodelistParams.format === DOWNLOAD_FORMAT_TYPE_CSV &&
                (
                  downloadHierarchicalCodelistParams.csvSeparator === null ||
                  downloadHierarchicalCodelistParams.csvSeparator.length !== 1 ||
                  downloadHierarchicalCodelistParams.csvLanguage === null
                ))
            }
          >
            {t('commons.buttons.download.title')}
          </Button>
        </div>
      }
      width={MODAL_WIDTH_SM}
      title={
        downloadHierarchicalCodelistTriplets && downloadHierarchicalCodelistTriplets.length > 1
          ? t('scenes.metaManager.commons.modals.download.titleMulti')
          : t('scenes.metaManager.commons.modals.download.title', {
            triplet: downloadHierarchicalCodelistTriplets
              ? getStringFromArtefactTriplet(downloadHierarchicalCodelistTriplets[0])
              : ""
          })
      }
    >
      <ArtefactDownloadForm
        downloadArtefactForm={downloadHierarchicalCodelistParams}
        onChange={onDownloadChange}
        options={getArtefactDownloadOptions(
          t,
          (downloadHierarchicalCodelistTriplets && downloadHierarchicalCodelistTriplets.length > 1)
            ? ARTEFACT_TYPE_MULTIPLE
            : ARTEFACT_TYPE_HIERARCHICAL_CODELIST
        )}
        hasReferences
      />
    </EnhancedModal>
  </Fragment>;

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps)
)(HierarchicalCodelists);


// WEBPACK FOOTER //
// ./src/scenes/meta-manager/hierarchical-codelists/index.jsx